import styled from 'styled-components';

export const Note = styled.div`
  max-width: 400px;
  font-size: 10px;
`;
